import { TabPanel } from '@mui/lab';
import { CircularProgress } from '@mui/material';
import { FormikProps } from 'formik';
import { EditLayoutItemFormikValues } from '../EditLayoutItemDialog';
import useConditionData from 'hooks/useConditionData';
import ConditionEditor from 'components/GlobalDialog/AddFieldTemplate/components/ConditionConfig/ConditionEditor';

interface LayoutVisibilityTabProps {
  formik: FormikProps<EditLayoutItemFormikValues>;
  disabled?: boolean;
}
export default function LayoutVisibilityTab({
  formik,
  disabled,
}: LayoutVisibilityTabProps) {
  const { loading } = useConditionData();

  return (
    <TabPanel
      value="2"
      sx={{
        pl: 0,
        pr: 0,
        minHeight: 300,
      }}
    >
      {loading ? (
        <CircularProgress sx={{ mb: 2 }} />
      ) : (
        <ConditionEditor
          onChange={group => formik.setFieldValue('isVisible', group)}
          rootGroup={formik.values.isVisible}
          disabled={disabled}
        />
      )}
    </TabPanel>
  );
}
